module.exports = __webpack_public_path__ + "assets/clear_text-5630b8.svg";